import * as contentConfiguration from "./configuration";
import * as contentStyles from "./styles";

export { contentConfiguration, contentStyles };
